// documentPreviewPrintStyles.js
//
// Print stylesheet for Proposal / Invoice / Purchase Order Preview document sheets.

export const DOCUMENT_PREVIEW_PRINT_STYLES = `
  * {
    box-sizing: border-box;
  }

  html,
  body {
    background: #ffffff;
    color: #000000;
    font-family: Arial, Helvetica, sans-serif;
    height: auto;
    margin: 0;
    min-height: 0;
    overflow: visible;
    padding: 0;
  }

  .proposal-preview-modal-body,
  .invoice-preview-modal-body,
  .purchase-order-preview-modal-body,
  .proposal-preview-modal-section,
  .invoice-preview-modal-section,
  .purchase-order-preview-modal-section,
  .proposal-preview-items-container,
  .invoice-preview-items-container,
  .purchase-order-preview-items-container,
  .po-general-info,
  .purchase-order-items-scroll,
  .purchase-order-items-footer,
  .document-rich-text-section,
  .document-rich-text-section-body {
    height: auto !important;
    max-height: none !important;
    min-height: 0 !important;
    overflow: visible !important;
  }

  .proposal-preview-modal-body,
  .invoice-preview-modal-body,
  .purchase-order-preview-modal-body {
    display: flex;
    flex-direction: column;
    gap: 28px;
    margin: 0 auto;
    max-width: 960px;
    padding: 24px 28px;
  }

  .proposal-preview-modal-section,
  .invoice-preview-modal-section,
  .purchase-order-preview-modal-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    page-break-inside: avoid;
  }

  .po-general-info {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 0;
    width: 100%;
  }

  .po-general-info-parties {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .po-general-info-party,
  .po-general-info-company,
  .po-general-info-company-text,
  .po-general-info-meta,
  .po-general-info-fields,
  .po-general-info-field {
    min-width: 0;
  }

  .po-general-info-company {
    align-items: flex-start;
    display: flex;
    gap: 12px;
  }

  .po-general-info-company-title,
  .po-general-info-title,
  .po-general-info-party-title {
    color: #000000;
    font-weight: 700;
  }

  .po-general-info-title {
    font-size: 22px;
    line-height: 1.3;
  }

  .po-general-info-label {
    color: #444444;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .po-general-info-value,
  .po-general-info-muted,
  .document-party-details,
  .document-party-details * {
    color: #000000;
  }

  .po-general-info-icon-button,
  .po-general-info-icon-static {
    cursor: default;
    flex: 0 0 80px;
    height: 80px;
    overflow: hidden;
    pointer-events: none;
    width: 80px;
  }

  /* BaseCover styles are not loaded in the print iframe — pin icon size. */
  .base-cover-container {
    border-radius: 50%;
    flex: 0 0 80px !important;
    height: 80px !important;
    max-height: 80px !important;
    max-width: 80px !important;
    overflow: hidden !important;
    width: 80px !important;
  }

  .base-cover-image,
  .base-cover-shimmer,
  .base-cover-initial {
    display: block;
    height: 100% !important;
    max-height: 80px;
    max-width: 80px;
    object-fit: cover;
    width: 100% !important;
  }

  .base-cover-initial {
    align-items: center;
    display: flex;
    font-size: 40px;
    justify-content: center;
  }

  .purchase-order-items-title {
    color: #000000;
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 8px;
  }

  .purchase-order-items-table {
    border-collapse: collapse;
    color: #000000;
    width: 100%;
  }

  .purchase-order-items-table th,
  .purchase-order-items-table td {
    border-bottom: 1px solid #cccccc;
    font-size: 12px;
    padding: 8px 6px;
    text-align: left;
    vertical-align: top;
  }

  .purchase-order-items-table th {
    border-bottom: 1px solid #000000;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .purchase-order-items-col-money,
  .proposal-items-col-money,
  .invoice-items-col-money,
  .proposal-items-col-markup,
  .invoice-items-col-markup,
  .purchase-order-items-col-unit-price,
  .purchase-order-items-col-total,
  .purchase-order-items-col-qty {
    text-align: right;
    white-space: nowrap;
  }

  .purchase-order-items-item-cell {
    align-items: flex-start;
    display: flex;
    gap: 10px;
  }

  .purchase-order-items-thumb {
    flex: 0 0 auto;
    height: 40px;
    overflow: hidden;
    width: 40px;
  }

  .purchase-order-items-thumb img {
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }

  .proposal-preview-items-title,
  .invoice-preview-items-title,
  .purchase-order-preview-items-title {
    font-weight: 600;
  }

  .proposal-preview-items-description,
  .invoice-preview-items-description,
  .purchase-order-preview-items-description {
    color: #444444;
    font-size: 11px;
    margin-top: 2px;
  }

  .purchase-order-items-muted {
    color: #888888;
  }

  .purchase-order-items-footer {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-left: auto;
    margin-top: 16px;
    max-width: 240px;
    width: 100%;
  }

  .purchase-order-items-footer-row {
    display: flex;
    justify-content: space-between;
    gap: 16px;
  }

  .purchase-order-items-footer-rule {
    border: none;
    border-top: 1px solid #000000;
    margin: 4px 0;
  }

  .purchase-order-items-footer-row.is-emphasis .purchase-order-items-footer-label,
  .purchase-order-items-footer-row.is-emphasis .purchase-order-items-footer-value {
    font-weight: 700;
  }

  .document-rich-text-section-title {
    color: #444444;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  .document-rich-text-section-body,
  .document-rich-text-section-body * {
    color: #000000 !important;
  }

  .ProseMirror {
    outline: none;
  }

  a {
    color: #000000;
    text-decoration: underline;
  }

  @page {
    margin: 0.5in;
  }
`;
